import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "cartpreview item",
  "data-type": "cart"
}
const _hoisted_2 = { class: "item" }
const _hoisted_3 = {
  key: 0,
  class: "button",
  "data-type": "hover",
  "aria-label": "Carrello"
}
const _hoisted_4 = ["data-notify"]
const _hoisted_5 = {
  key: 0,
  class: "notify"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["data-notify"]
const _hoisted_8 = {
  key: 0,
  class: "notify"
}
const _hoisted_9 = {
  key: 0,
  class: "list-items"
}
const _hoisted_10 = { class: "rows" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "image" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "noimg"
}
const _hoisted_16 = { class: "desc" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "variant" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "cod" }
const _hoisted_21 = { class: "qty" }
const _hoisted_22 = { class: "price" }
const _hoisted_23 = { class: "unit" }
const _hoisted_24 = { class: "footer" }
const _hoisted_25 = {
  key: 0,
  class: "discount"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "unit" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 2,
  class: "discount-alert"
}
const _hoisted_30 = { class: "checkout" }
const _hoisted_31 = { class: "link" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "txt" }
const _hoisted_34 = { class: "total" }
const _hoisted_35 = { class: "label" }
const _hoisted_36 = { class: "price" }
const _hoisted_37 = { class: "unit" }
const _hoisted_38 = { class: "value" }
const _hoisted_39 = {
  key: 1,
  class: "minimumtotal"
}
const _hoisted_40 = {
  key: 2,
  class: "minimumtotalgap"
}
const _hoisted_41 = {
  key: 0,
  class: "minimumtotalgap"
}
const _hoisted_42 = { class: "calltoaction" }
const _hoisted_43 = ["href"]
const _hoisted_44 = {
  key: 1,
  class: "notfound"
}
const _hoisted_45 = { class: "title" }
const _hoisted_46 = { class: "desc" }
const _hoisted_47 = ["innerHTML"]

import { computed } from "vue";
import { useStore } from "vuex";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'CartPreview',
  setup(__props) {

const store = useStore();

const localizer = Localizer;
const routes = (window as any).App.routes;

const cart = computed(() => {
    return store.getters["cartStore/cart"];
});

const isCartPreviewVisible = computed(() => {
    return store.getters["cartStore/isCartPreviewVisible"];
});

function setExpanding(isVisible: boolean) {
    store.commit("cartStore/setIsCartPreviewVisible", isVisible);
}

function setExpandingClass() {
    return isCartPreviewVisible.value ? "exp show" : "exp";
}

function formatPrice(data: any) {
    return Number(data).toFixed(2).replace(".", ",");
}

function openCompleteOrder() {
    GTagHelper.sendEvent("click", "complete_order", "");
}

function goToCart() {
    GTagHelper.sendEvent("click", "go_to_cart", "");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (cart.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (setExpanding(true))),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (setExpanding(false)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            (cart.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_3, [
                  _createElementVNode("div", {
                    "data-notify": cart.value.cartQuantity > 0
                  }, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", {
                      class: "icon fastic-cart",
                      role: "none"
                    }, null, -1)),
                    (cart.value.cartQuantity > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(cart.value.cartQuantity), 1))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_4)
                ]))
              : _createCommentVNode("", true),
            (cart.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _unref(routes).Cart_Detail,
                  class: "button",
                  "data-type": "link"
                }, [
                  _createElementVNode("div", {
                    "data-notify": cart.value.cartQuantity > 0
                  }, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "icon fastic-cart" }, null, -1)),
                    (cart.value.cartQuantity > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(cart.value.cartQuantity), 1))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_7)
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          (cart.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(setExpandingClass())
              }, [
                (cart.value.cartQuantity > 0)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value.cartRows, (cartRow) => {
                          return (_openBlock(), _createElementBlock("article", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              (cartRow.productImageUrl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("img", {
                                      src: cartRow.productImageUrl,
                                      width: "100",
                                      height: "100",
                                      alt: "",
                                      loading: "lazy"
                                    }, null, 8, _hoisted_14)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("div", { class: "icon fa fa-camera-retro" }, null, -1),
                                    _createElementVNode("img", {
                                      src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                                      width: "1",
                                      height: "1"
                                    }, null, -1)
                                  ]))]))
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, _toDisplayString(cartRow.productTitle), 1),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(cartRow.variantTitle), 1),
                                _createTextVNode(_toDisplayString(cartRow.variantDescription), 1)
                              ]),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(localizer).get("Checkout.Common.Cod")) + " " + _toDisplayString(cartRow.productCode), 1),
                              _createElementVNode("div", _hoisted_21, [
                                _createTextVNode(_toDisplayString(_unref(localizer).get("Checkout.Common.Quantity")) + ": ", 1),
                                _createElementVNode("strong", null, _toDisplayString(cartRow.quantity), 1)
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                                _createTextVNode(" " + _toDisplayString(cartRow.rowPrice), 1)
                              ])
                            ])
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("footer", _hoisted_24, [
                        (cart.value.couponCode)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createTextVNode(_toDisplayString(_unref(localizer).get("Checkout.Common.Discount")) + ": ", 1),
                              (cart.value.couponDiscountMode === 'Amount')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                                    _createTextVNode("-" + _toDisplayString(formatPrice(cart.value.couponDiscount)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (cart.value.couponDiscountMode === 'Percentage')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                    _createTextVNode(" -" + _toDisplayString(cart.value.couponDiscount), 1),
                                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "unit" }, "%", -1))
                                  ]))
                                : _createCommentVNode("", true),
                              (cart.value.CouponMinimumGap)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(localizer).get("Checkout.Common.CouponGap_Start")) + " " + _toDisplayString(formatPrice(cart.value.couponMinimumGap)) + " " + _toDisplayString(_unref(localizer).get("Checkout.Common.CouponGap_End")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("a", {
                              href: _unref(routes).Cart_Detail,
                              class: "no-uline",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToCart()))
                            }, [
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "icon fastic-cart" }, null, -1)),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(localizer).get("Checkout.Common.GoToCart")), 1)
                            ], 8, _hoisted_32)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(localizer).get("Checkout.Common.TotalIva")), 1),
                            _createElementVNode("span", _hoisted_36, [
                              _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                              _createElementVNode("span", _hoisted_38, _toDisplayString(cart.value.cartTotal), 1)
                            ])
                          ])
                        ]),
                        (cart.value.minimumTotalGap)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotal")) + " " + _toDisplayString(cart.value.minimumTotal), 1))
                          : _createCommentVNode("", true),
                        (cart.value.minimumTotalGap)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotalGap_Start")) + " " + _toDisplayString(cart.value.minimumTotalGap) + " " + _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotalGap_End")), 1))
                          : _createCommentVNode("", true),
                        (cart.value.shippingMode != 'ExWork')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (!cart.value.freeShippingGap)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(localizer).get("Checkout.Common.FreeShipping")), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("a", {
                            href: _unref(routes).Checkout_Summary,
                            class: "button",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (openCompleteOrder()))
                          }, _toDisplayString(_unref(localizer).get("Checkout.Common.CompleteOrder")), 9, _hoisted_43)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(localizer).get("Checkout.Common.Empty_Title")), 1),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("span", {
                          innerHTML: _unref(localizer).get('Checkout.Common.Empty_Description', _unref(routes).Account_Login, _unref(localizer).get('Checkout.Common.Empty_Link'))
                        }, null, 8, _hoisted_47)
                      ])
                    ]))
              ], 2))
            : _createCommentVNode("", true)
        ], 32))
      : _createCommentVNode("", true)
  ]))
}
}

})